import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import { toast } from 'sonner'
import App from './App.tsx'
import './index.css'

if (import.meta.env.DEV && "serviceWorker" in navigator) {
  // Clean up any service worker left behind from a prior production visit on
  // this origin so dev never serves stale cached assets.
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => void registration.unregister());
  });
}

if (import.meta.env.PROD) {
  // When a new build is deployed, prompt the user to reload rather than
  // force-reloading them (which could interrupt a video or an unsaved form).
  const updateSW = registerSW({
    onNeedRefresh() {
      toast('A new version is available.', {
        action: { label: 'Refresh', onClick: () => void updateSW(true) },
        duration: Infinity,
      });
    },
    onRegisteredSW(_swUrl, registration) {
      // Long-lived tabs: poll for a new service worker hourly so frequent
      // deploys are noticed without waiting for a navigation or the browser's
      // ~24h default update check.
      if (registration) {
        setInterval(() => void registration.update(), 60 * 60 * 1000);
      }
    },
  });
}

createRoot(document.getElementById("root")!).render(<App />);
